import React from "react";

function createTextLinks(text) {
  // remove g option - replace only first link
  let linkedText = (text || "").replace(/([^\S]|^)(((https?\:\/\/)|(www\.))(\S+))/i, function (match, space, url) {
    let hyperlink = url;
    if (!hyperlink.match("^https?://")) {
      hyperlink = `http://${hyperlink}`;
    }
    return `${space}<a href="${hyperlink}" class="chat__link"><span>${url}</span> <b>Перейти ></b></a>`;
  });

  return linkedText;
}

export const Linker = (props) => {
  return <div dangerouslySetInnerHTML={{ __html: createTextLinks(props.text) }}></div>;
};
